import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { saveMailLogsToStorage, truncateMailLogs } from '../../../models/LogModel';
import { useNotificationCount } from '../../../context/NotificationCountContext';

const DeleteAllMailLogsModal = ({showModal, setShowModal, fetchLogs, limit, page}) => {

  const { notificationCount, setNotificationCount } = useNotificationCount();

    const navigate = useNavigate(); 

    const { state } = useAuth(); 

    let user_data = state.user_data;
    
    const loader = document.getElementById('loading');

    const [loading, setLoading] = useState(false);

    const closeModal = () =>{
        setShowModal(false);
    }

    const deleteAllMailLogs = async () => {
        // Start the loading state
        loader.style.display = 'block';
    
        try {
          const response = await truncateMailLogs(user_data.user_token);
        
          if (response.status) {
            toast.success(response.message);
    
            closeModal();
    
            saveMailLogsToStorage(response.data.notes, response.data.pagination);
    
            fetchLogs(limit, page); 

            setNotificationCount(localStorage.getItem('unread_notification_count'));
          }
          else{
            toast.error(response.message);
          }  
          
        } catch (error) {
          apiError(error);

          if (error.response.data.invalid_token==1) {
            navigate('/re-login');
          }
        }
    
        // Stop the loading state
        loader.style.display = 'none';
    };


    return (
        <Modal show={showModal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Delete All Mail Logs</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
                <p>Do you want to delete all mail logs ? This process can't be undone</p>
            </Modal.Body>
    
            <Modal.Footer>
                <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={deleteAllMailLogs}>Delete</button>
            </Modal.Footer>
        </Modal>
    ); 

}; 


export default DeleteAllMailLogsModal;    